import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../@/components/ui/select";

interface SourceOfInfoDropDownProps {
  infoSource: string | undefined;
  setInfoSource: (sourceOfInfo: string) => void;
}

const SourceOfInfoDropDown: React.FC<SourceOfInfoDropDownProps> = ({
  infoSource,
  setInfoSource,
}) => {
  const handleInfoSourceChange = (sourceOfInfo: string) => {
    setInfoSource(sourceOfInfo);
  };
  return (
    <Select value={infoSource} onValueChange={handleInfoSourceChange}>
      <SelectTrigger className="mt-1 py-5 xxl:py-6 w-full border border-gray-300 focus:border-none focus:outline-customGreenColor rounded-lg">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Select an option</SelectLabel>
          <SelectItem value="Search engine">Search engine</SelectItem>
          <SelectItem value="Social Media">Social Media</SelectItem>
          <SelectItem value="Colleague or friend">
            Colleague or friend
          </SelectItem>
          <SelectItem value="Industry event">Industry event</SelectItem>
          <SelectItem value="Press coverage">Press coverage</SelectItem>
          <SelectItem value="Other">Other</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
export default SourceOfInfoDropDown;
